const _i18n_error = {
  getpattern : {
    EN: `load failed pattern`,
    KO: `load failed pattern`,
    JP: `ロード失敗パターン`
  }
}

const i18n_toastr = { _i18n_error }

export default i18n_toastr